<template>
  <!--页面加载动画-->
  <div class="items">
    <div class="items-wrap">
      <span class="lables">手机号</span>
      <div class="from-right">
        <input
          type="tel"
          class="input-text tellCode"
          :readonly="disabled"
          @input="tellhandle"
          placeholder="请输入您的手机号"
        />
        <i class="iconfont icon-fabiaowenzhang"></i>
      </div>
    </div>
    <div class="items-wrap">
      <span class="lables">验证码</span>
      <div class="from-right">
        <input
          type="text"
          class="input-text veryNumber"
          @blur="veryhandle"
          placeholder="请输入验证码"
        />
        <span @click="getVery" :class="'veryTxt status' + status">{{
          veryTxt ? veryTxt + "秒后重新获取" : "获取验证码"
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
var timor;
export default {
  data() {
    return {
      tell: "", //手机号
      very: "", //验证码
      disabled: false, //手机号是否禁止修改
      status: 0, //验证码状态- 0:无法获取 ； 1：可以获取；2：正在倒计时
      hasSendVery: false, //短险是否发送成功
      veryTxt: "",
      timor: null,
      params: null, //获取验证码参数
    };
  },
  props: ["selectData"],
  mounted() {
    if (this.selectData.defaultTell) {
      this.status = 1;
      this.tell = this.selectData.defaultTell;
    }
    if (this.selectData.readOnly) {
      this.disabled = true;
    }
  },
  methods: {
    //   手机号回调
    tellhandle(e) {
      let value = e.target.value;
      if (this.$regulars.isPhone(value)) {
        if (this.tell && this.tell != value) {
          this.very = "";
          this.setError("手机号修改后，您还没有重新发送验证码！");
          this.reloadCount();
        }
        this.status = 1;
        this.tell = value;
      } else {
        this.status = 0;
      }
    },
    //   验证码回调
    veryhandle(e) {
      if (this.tell) {
        this.very = e.target.value;
        this.setError();
        this.getResult();
      }
    },
    async getVery() {
      if (this.status == 0 || this.status == 2) return;
      if (!this.tell) {
        return this.$notice.msg("请您先正确填写手机号！");
      }
      if (this.status == 1) {
        const signNumber = await this.$tools.phoneSignature();
        this.$http({
          url: "/insure/sendcode",
          query: {
            phone: this.tell,
            signature: signNumber,
          },
        })
          .then((r) => {
            this.countDown(60);
            this.$notice.msg("验证码已发送，请注意查看您的手机短信！");
            this.hasSendVery = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    countDown(number) {
      this.status = 2;
      this.veryTxt = number;
      this.timor = setInterval(() => {
        number--;
        if (number < 1) {
          this.reloadCount();
          return;
        }
        this.veryTxt = number;
      }, 1000);
    },
    reloadCount() {
      clearInterval(this.timor);
      this.veryTxt = "";
      this.status = 1;
    },
    getResult() {
      //选择后回调到父组件
      let value = {
        tell: this.tell,
        very: this.very, //验证码
      };
      this.selectData.elementValue = value;
    },
    setError(msg) {
      if (!msg) {
        return (this.selectData.errorMsg = "");
      }
      this.selectData.errorMsg = msg;
    },
  },
};
</script>

<style lang="scss" scoped>
.items {
  .lables {
    width: 25%;
  }
  .items-wrap {
    padding: 3px 0;
  }
  .border {
    border-bottom: 1px solid #ececec;
  }
  .from-right {
    width: 74%;
  }
  .from-right {
    display: flex !important;
    flex-direction: row;
    justify-content: flex-start;
  }
  .veryNumber {
    width: 50%;
  }
  .veryTxt {
    display: inline-block;
    width: 45%;
    height: 60px;
    line-height: 60px;
    border-radius: 60px;
    background-color: #0084ff;
    color: #fff;
    text-align: center;
    font-size: 26px;
  }
  .status0,
  .status2 {
    background-color: #999;
    color: #fff;
  }
}
</style>
